import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatPopularity, formatRating, getCategoryName } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - ${getCategoryName(movie.category)}在线观看信息`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          {typeof rank === "number" ? (
            <span className="flex h-6 min-w-6 items-center justify-center rounded-md bg-primary-500 px-1.5 text-xs font-bold text-background-50">
              {rank}
            </span>
          ) : (
            <span className="rounded-md bg-black/55 px-2 py-0.5 text-[11px] text-background-50">
              {getCategoryName(movie.category)}
            </span>
          )}
          <span className="flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-[11px] font-medium text-accent-300">
            <i className="ri-star-fill text-[10px]" />
            {formatRating(movie.rating)}
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="truncate text-xs text-foreground-500">
          {movie.year} · {movie.region}
        </p>
        <div className="mt-auto flex items-center justify-between pt-1 text-xs text-foreground-500">
          <span className="truncate">{movie.genres.slice(0, 2).join(" / ")}</span>
          <span className="flex shrink-0 items-center gap-1">
            <i className="ri-fire-line text-primary-500" />
            {formatPopularity(movie.popularity)}
          </span>
        </div>
      </div>
    </Link>
  );
}